var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6178 2.92708C13.3188 2.00608 12.0158 2.00608 11.7158 2.92708L10.1968 7.60108C10.1314 7.80173 10.0042 7.97654 9.83337 8.10048C9.66255 8.22442 9.45689 8.29113 9.24584 8.29108H4.33184C3.36384 8.29108 2.95984 9.53108 3.74384 10.1011L7.71984 12.9891C7.89064 13.1132 8.01774 13.2883 8.08295 13.4891C8.14816 13.6899 8.14812 13.9063 8.08284 14.1071L6.56484 18.7811C6.26484 19.7021 7.31984 20.4691 8.10284 19.8991L12.0788 17.0111C12.2497 16.8869 12.4556 16.8199 12.6668 16.8199C12.8781 16.8199 13.084 16.8869 13.2548 17.0111L17.2308 19.8991C18.0138 20.4691 19.0688 19.7031 18.7688 18.7811L17.2508 14.1071C17.1856 13.9063 17.1855 13.6899 17.2507 13.4891C17.3159 13.2883 17.4431 13.1132 17.6138 12.9891L21.5898 10.1011C22.3728 9.53108 21.9708 8.29108 21.0018 8.29108H16.0868C15.876 8.29092 15.6705 8.22411 15.4999 8.10018C15.3293 7.97626 15.2022 7.80157 15.1368 7.60108L13.6178 2.92708Z",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.ce348815410e8a1e17c605cf9bb249fc.svg";
export { ForwardRef as ReactComponent };